import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { BASE_URL } from "../store/api";
import { RootState } from "../store/rootReducer";

export const AppLoading = () => {
  const isLoading =  useSelector((state: RootState) => state.authorization.isLoading);
  const error =  useSelector((state: RootState) => state.authorization.error);

  const [theDots, setDots] = useState<string>("");
  const [status, setStatus] = useState<string>("Memuat data");

  useEffect(() => {
    if (!isLoading) return;
    if (theDots === '.....') {
      setDots('');
    } else {
      setTimeout(() => {
        setDots(theDots + ".");
      }, 250);
    }
  }, [theDots]);

  useEffect(() => {
    setTimeout(() => { setStatus("Memulai proses autentikasi") }, 500);
  }, []);
    
  useEffect(() => {
    if (!isLoading) return;
    if (error) {
      setTimeout(() => { setStatus("Proses autentikasi gagal. Mencoba melakukan autentikasi ulang") }, 500);
    }
  }, [error])

  return (
    <AppLoadingWrapper>
      <div className="splashscreen">
        <div className="splashscreen--description">
          <img className="logo" src="/images/logo.png" alt="UMN" />

          <h1>Sistem Kerjasama</h1>
          <h4>Mohon menunggu sebentar, sistem dalam proses untuk memuat data aplikasi.</h4>

          <div className="clearspace" />
          { error ? (
            <React.Fragment>
              <p>{ error.message }</p>

              <br/>
              <p>Apabila sistem masih tidak dapat diakses, silahkan hubungi tim IT Universitas Multimedia Nusantara.</p>

              <br/>
              <p>
                <a href={`${BASE_URL}account/login`} className="btn btn-primary">Coba Login SSO</a> &nbsp;
                <a href="https://helpdesk.umn.ac.id" className="btn btn-warning">Helpdesk</a>
              </p>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <p>{status}{ theDots }</p>
            </React.Fragment>
          ) }
          <div className="clearspace" />

          <h3>© 2021 Universitas Multimedia Nusantara</h3>
          <h2>Sistem Kerjasama UMN merupakan sistem yang dibuat untuk mempermudah pencatatan dan pembuatan laporan perjanjian kerjasama antara UMN dengan instansi lainnya.</h2>
        </div>
        <div className="splashscreen--art">
          <img src="/images/login.jpg" alt="" />
        </div>
      </div>
    </AppLoadingWrapper>
  );
}

const AppLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: #ecf0f5;

  & .clearspace {
    height: 75px;
  }

  & .splashscreen {
    display: flex;
    color: #fff;
    overflow: hidden;
    max-width: 800px;
    border-radius: 10px;
    background-color: #2b405d;
    box-shadow: 0px 0px 10px 0px #8d8d8dbe;
  }

  & .splashscreen--description {
    padding: 50px;

    & * { margin: 0px; }
    & h1 { font-size: 24px; margin-bottom: 5px; }
    & h2, & h4 { font-size: 14px; color: #6291bf; line-height: 140%; }
    & h3 { font-size: 14px; font-weight: bold; color: #fff; margin-bottom: 5px; }

    & .logo {
      width: 100px;
      display: block;
      margin-bottom: 20px;
    }
  }

  & .splashscreen--art {
    display: flex;
    width: 350px;
    min-width: 350px;
    align-self: stretch;
    align-items: stretch;

    & > img {
      width: 100%;
      object-fit: cover;
    }
  }

`;